<div [formGroup]="formGroup" class="w-full py-1 px-2">
  <div class="mb-1.5 flex flex-col">
    <label class="block text-2sm font-semibold text-gray-700 dark:text-gray-300">
      {{ fields.displayName }}
      <span *ngIf="fields.isRequired" class="text-danger">*</span>
    </label>
  </div>

  <div class="flex flex-col gap-3">
    <!-- Clickable Upload Box -->
    <div
      class="upload-box-premium flex items-center justify-center p-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-[#1b1c24] hover:border-blue-500 dark:hover:border-blue-500 transition-all duration-150 cursor-pointer"
      (click)="openFilePicker($event)"
      [class.dragover]="isDragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onFileDrop($event)"
    >
      <span class="text-sm font-medium text-gray-700 dark:text-gray-300 select-none">
        {{ fields.placeholder || 'Upload file' }}
      </span>
      <input
        type="file"
        #fileInput
        hidden
        (change)="onFileSelected($event)"
        accept="image/png, image/jpeg, image/svg+xml, image/webp"
      />
    </div>

    <!-- Preview Container (Matches the Yellow KAS Logo preview in the mockup) -->
    <div *ngIf="previewUrl" class="relative group self-start">
      <div class="h-20 w-20 rounded-md border border-gray-300 dark:border-gray-700 overflow-hidden bg-gray-50 dark:bg-[#111217] flex items-center justify-center shadow-sm">
        <img [src]="previewUrl" alt="Icon Preview" class="h-full w-full object-contain" />
      </div>
      <button
        type="button"
        class="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-red-500 text-white flex items-center justify-center shadow hover:bg-red-600 transition-all duration-150"
        (click)="removeFile($event)"
      >
        <span class="text-xs font-bold leading-none">&times;</span>
      </button>
    </div>

    <!-- Helper Description text -->
    <span *ngIf="fields.helpText || fields.uiOptions?.subText" class="text-xs text-gray-500 dark:text-gray-400 select-none leading-normal">
      {{ fields.helpText || fields.uiOptions?.subText }}
    </span>
  </div>

  <!-- Validation Error Display -->
  <div
    *ngIf="formGroup.get(fields.fieldName)?.touched && formGroup.get(fields.fieldName)?.invalid"
    class="text-danger text-2sm mt-1"
  >
    Please upload {{ fields.displayName }}
  </div>
</div>
